module.exports = __webpack_public_path__ + "static/media/c-sharp.0511565f.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/c-sharp.png
// module id = 487
// module chunks = 0